<template>
  <footer class="footer footer-white">
    <div class="container">
      <a class="footer-brand" href="https:///www.creative-tim.com">Now Ui Kit PRO</a>
      <ul class="pull-center">
        <li>
          <a href="#pablo" class="nav-link">
            Creative Tim
          </a>
        </li>
        <li>
          <a href="#pablo" class="nav-link">
            About Us
          </a>
        </li>
        <li>
          <a href="#pablo" class="nav-link">
            Blog
          </a>
        </li>
        <li>
          <a href="#pablo" class="nav-link">
            Licenses
          </a>
        </li>
      </ul>
      <ul class="social-buttons pull-right">
        <li>
          <a href="https://twitter.com/CreativeTim" target="_blank"
             class="btn btn-icon btn-neutral btn-twitter">
            <i class="fab fa-twitter"></i>
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/CreativeTim" target="_blank"
             class="btn btn-icon btn-neutral btn-dribbble">
            <i class="fab fa-dribbble"></i>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/CreativeTimOfficial" target="_blank"
             class="btn btn-icon btn-neutral btn-google">
            <i class="fab fa-google-plus"></i>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>
<script>
  import Navbar from "@/components/Navbar/Navbar";
  export default {
    components: {Navbar},
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style>
</style>
